// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

/**
 * A list of allowed app categories
 */
export const zAppCategoriesBody = z.object({
    categories: z.array(z.string())
});

/**
 * Accessability of the BusinessPartner to Identities from its Domain
 */
export const zBusinessPartnerAccessabilityEnum = z.enum(['requestToJoin', 'inviteOnly']);

/**
 * BusinessPartner Properties
 */
export const zBusinessPartnerPatchBody = z.object({
    accessability: zBusinessPartnerAccessabilityEnum.optional()
});

/**
 * string of at most 150 characters
 */
export const zCharacterString150 = z.string().max(150);

/**
 * string of at most 255 characters
 */
export const zCharacterString255 = z.string().max(255);

export const zCharacterStringBcp47 = z.string().max(36).regex(/^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})*$/);

export const zCharacterStringClientId = z.string().min(4).max(128).regex(/^[0-9A-Za-z_\-]+$/);

export const zCharacterStringDomain = z.string().min(3).max(255).regex(/^\S+\.\S+$/);

export const zCharacterStringEmail = z.string().email().min(6).max(255).regex(/^\S+@\S+\.\S+$/);

export const zCharacterStringHomepageUrl = z.string().url().max(250).regex(/^(https:\/\/.*|\/.*\/)$/);

export const zCharacterStringHomepageUrlOrEmpty = z.union([
    z.string().max(0),
    z.string().url().max(250).regex(/^(https:\/\/.*|\/.*\/)$/)
]);

export const zCharacterStringSecureUrl = z.string().url().max(250).regex(/^https:\/\/.*/);

export const zCharacterStringType = z.string().min(1).max(32).regex(/^[0-9A-Za-z_]+$/);

export const zCharacterStringUrn = z.string().min(10).max(255).regex(/^urn:.*/);

/**
 * a Universally Unique IDentifier in conformance with IETF RFC 4122
 */
export const zCharacterStringUuid = z.string().max(36).regex(/^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/);

/**
 * BusinessPartner Properties
 */
export const zBusinessPartnerBody = z.object({
    accessability: zBusinessPartnerAccessabilityEnum,
    archived: z.boolean(),
    createdAt: z.string().datetime(),
    extId: zCharacterStringUrn,
    iconURL: zCharacterStringSecureUrl.optional(),
    id: zCharacterStringUuid,
    modifiedAt: z.string().datetime(),
    name: zCharacterString255,
    ownerIdentityId: zCharacterStringUuid,
    parentBusinessPartnerId: zCharacterStringUuid.optional(),
    trn: zCharacterStringUrn,
    type: zCharacterStringType
});

/**
 * A list of businessPartnerBody
 */
export const zBusinessPartnerListBody = z.object({
    items: z.array(zBusinessPartnerBody)
});

/**
 * BusinessPartner Properties
 */
export const zBusinessPartnerPostBody = z.object({
    accessability: zBusinessPartnerAccessabilityEnum,
    archived: z.boolean().optional(),
    extId: zCharacterStringUrn,
    name: zCharacterString255,
    ownerIdentityId: zCharacterStringUuid,
    parentBusinessPartnerId: zCharacterStringUuid.optional(),
    type: zCharacterStringType
});

/**
 * OAuth client grant options
 */
export const zClientOAuthGrantEnum = z.enum([
    '*',
    'authorization_code',
    'implicit',
    'refresh',
    'client_credentials',
    'device_authorization',
    'token_exchange'
]);

/**
 * OAuth client require options
 */
export const zClientOAuthRequireEnum = z.enum(['*', 'pkce']);

/**
 * OAuth Client Configuration
 */
export const zClientOAuthConfig = z.object({
    grants: z.array(zClientOAuthGrantEnum).max(8),
    policies: z.array(z.string().max(150)).max(8).optional(),
    redirectURLs: z.array(z.string().max(250).regex(/^(https?):\/\/[-a-zA-Z0-9+&@#\/%?=~_|!*:,.;]*[-a-zA-Z0-9+&@#\/%=~_*|]$/)).max(8),
    require: z.array(zClientOAuthRequireEnum).max(8).optional(),
    scopes: z.array(z.string().max(150)).max(16)
});

/**
 * OAuth Client Properties
 */
export const zClientBody = z.object({
    OAuthConfig: zClientOAuthConfig,
    appPolicy: zCharacterString150,
    authnPolicy: zCharacterString150.optional(),
    businessPartnerId: zCharacterStringUuid,
    clientId: zCharacterStringClientId,
    clientSecret: z.string().max(250),
    createdAt: z.string().datetime(),
    description: zCharacterString255,
    effectiveOAuthConfig: zClientOAuthConfig.optional(),
    homepageURL: zCharacterStringHomepageUrl.optional(),
    iconURL: zCharacterStringSecureUrl.optional(),
    id: zCharacterStringUuid,
    modifiedAt: z.string().datetime(),
    name: zCharacterString255
});

/**
 * A list of clientBody
 */
export const zClientListBody = z.object({
    items: z.array(zClientBody)
});

/**
 * Client Properties
 */
export const zClientPatchBody = z.object({
    OAuthConfig: zClientOAuthConfig.optional(),
    appPolicy: zCharacterString150.optional(),
    authnPolicy: zCharacterString150.optional(),
    description: zCharacterString255.optional(),
    generateSecret: z.boolean().optional(),
    homepageURL: zCharacterStringHomepageUrlOrEmpty.optional(),
    name: zCharacterString255.optional()
});

/**
 * OAuth Client Properties
 */
export const zClientPostBody = z.object({
    OAuthConfig: zClientOAuthConfig,
    appPolicy: zCharacterString150,
    authnPolicy: zCharacterString150.optional(),
    clientId: zCharacterStringClientId.optional(),
    description: zCharacterString255,
    homepageURL: zCharacterStringHomepageUrl.optional(),
    name: zCharacterString255
});

export const zContextBusinessPartner = z.object({
    id: zCharacterStringUuid,
    name: zCharacterString255,
    trn: zCharacterStringUrn,
    type: zCharacterStringType
});

export const zContextIdentity = z.object({
    email: zCharacterStringEmail,
    id: zCharacterStringUuid,
    trn: zCharacterStringUrn
});

/**
 * present if current session has a profile.  no profile is valid for some applications.
 */
export const zContextProfile = z.object({
    canSwitch: z.boolean().optional(),
    description: zCharacterString255,
    displayName: zCharacterString255,
    id: zCharacterString255
});

/**
 * present if current session is by a Service Provider (dealer)
 */
export const zContextServiceProvider = z.object({
    id: zCharacterStringUuid,
    name: zCharacterString255,
    terms: z.string(),
    trn: zCharacterStringUrn,
    type: zCharacterStringType
});

/**
 * present if current session is by Topcon support
 */
export const zContextTopconSupport = z.object({
    id: zCharacterStringUuid,
    name: zCharacterString255,
    profileId: z.string(),
    trn: zCharacterStringUrn,
    type: zCharacterStringType
});

/**
 * Context information about the current session
 */
export const zContextBody = z.object({
    businessPartner: zContextBusinessPartner.optional(),
    identity: zContextIdentity.optional(),
    profile: zContextProfile.optional(),
    profileId: z.string().optional(),
    serviceProvider: zContextServiceProvider.optional(),
    topconSupport: zContextTopconSupport.optional()
});

/**
 * Domain Properties
 */
export const zDomainBody = z.object({
    businessPartnerId: zCharacterStringUuid,
    createdAt: z.string().datetime(),
    id: zCharacterStringUuid,
    identityProviderId: zCharacterStringUuid.optional(),
    modifiedAt: z.string().datetime(),
    name: zCharacterStringDomain,
    proofTXT: zCharacterString255,
    verified: z.boolean(),
    verifyErrors: z.array(z.string()).optional()
});

/**
 * A list of domainBody
 */
export const zDomainListBody = z.object({
    items: z.array(zDomainBody)
});

/**
 * Domain Properties
 */
export const zDomainPatchBody = z.object({
    identityProviderId: zCharacterStringUuid.optional()
});

/**
 * Domain Properties
 */
export const zDomainPostBody = z.object({
    identityProviderId: zCharacterStringUuid.optional(),
    name: zCharacterStringDomain
});

/**
 * ExternalIdentity Properties
 */
export const zExternalIdentityBody = z.object({
    email: zCharacterStringEmail,
    extId: zCharacterStringUrn,
    firstName: zCharacterString255,
    lastName: zCharacterString255,
    preferredLanguage: zCharacterStringBcp47.optional(),
    realm: zCharacterString255
});

/**
 * ExternalIdentity Properties
 */
export const zExternalIdentityPostBody = z.object({
    email: zCharacterStringEmail,
    emailVerified: z.boolean().optional(),
    extId: zCharacterStringUrn,
    firstName: zCharacterString255,
    lastName: zCharacterString255,
    preferredLanguage: zCharacterStringBcp47.optional(),
    realm: zCharacterString255,
    unarchive: z.boolean().optional()
});

/**
 * Identity Properties
 */
export const zIdentityBody = z.object({
    archived: z.boolean(),
    createdAt: z.string().datetime(),
    email: zCharacterStringEmail,
    externalIdentities: z.array(zExternalIdentityBody).optional(),
    firstName: zCharacterString255,
    id: zCharacterStringUuid,
    lastName: zCharacterString255,
    modifiedAt: z.string().datetime(),
    preferredLanguage: zCharacterStringBcp47.optional(),
    trn: zCharacterStringUrn
});

/**
 * A list of identityBody
 */
export const zIdentityListBody = z.object({
    items: z.array(zIdentityBody)
});

/**
 * Identity Patch Properties
 */
export const zIdentityPatchBody = z.object({
    archived: z.boolean().optional(),
    preferredLanguage: zCharacterStringBcp47.optional()
});

/**
 * Mappings from upstream token claims to the downstream token claims
 */
export const zIdpFieldMappings = z.object({
    email: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    preferredLanguage: z.string().optional()
});

/**
 * OIDC Configuration
 */
export const zIdpOidcConfig = z.object({
    algorithms: z.array(z.string().max(16)).max(5).optional(),
    authURL: zCharacterStringSecureUrl,
    clientId: z.string().max(250),
    clientSecret: z.string().max(250),
    issuerURL: zCharacterStringSecureUrl,
    jwksURL: zCharacterStringSecureUrl,
    tokenURL: zCharacterStringSecureUrl,
    userInfoURL: zCharacterStringSecureUrl
});

/**
 * OIDC Well Known Configuration
 */
export const zIdpOidcConfigWk = z.object({
    clientId: z.string().max(250),
    clientSecret: z.string().max(250),
    wellKnownConfigurationURL: zCharacterStringSecureUrl
});

/**
 * SAML Configuration
 */
export const zIdpSamlConfig = z.object({
    metaDataURL: zCharacterStringSecureUrl
});

/**
 * IdentityProvider Properties
 */
export const zIdentityProviderBody = z.object({
    OIDCConfig: zIdpOidcConfig.optional(),
    SAMLConfig: zIdpSamlConfig.optional(),
    businessPartnerId: zCharacterStringUuid,
    createdAt: z.string().datetime(),
    fieldMappings: zIdpFieldMappings,
    id: zCharacterStringUuid,
    metaDataURL: zCharacterStringSecureUrl.optional(),
    modifiedAt: z.string().datetime(),
    name: zCharacterString255,
    realm: zCharacterStringDomain,
    redirectURL: zCharacterStringSecureUrl.optional()
});

/**
 * A list of identityProvider
 */
export const zIdentityProviderListBody = z.object({
    items: z.array(zIdentityProviderBody)
});

/**
 * IdentityProvider Properties
 */
export const zIdentityProviderPatchBody = z.object({
    OIDCConfig: zIdpOidcConfig.optional(),
    SAMLConfig: zIdpSamlConfig.optional(),
    fieldMappings: zIdpFieldMappings.optional(),
    name: zCharacterString255.optional()
});

/**
 * IdentityProvider Properties
 */
export const zIdentityProviderPostBody = z.object({
    OIDCConfig: zIdpOidcConfig.optional(),
    OIDCConfigWK: zIdpOidcConfigWk.optional(),
    SAMLConfig: zIdpSamlConfig.optional(),
    fieldMappings: zIdpFieldMappings.optional(),
    name: zCharacterString255,
    realm: zCharacterStringDomain
});

/**
 * InviteToJoin Properties
 */
export const zInviteToJoinBody = z.object({
    businessPartner: zBusinessPartnerBody.optional(),
    businessPartnerId: zCharacterStringUuid,
    createdAt: z.string().datetime(),
    email: zCharacterStringEmail,
    id: zCharacterStringUuid,
    modifiedAt: z.string().datetime(),
    profileIds: z.array(z.string()).max(5)
});

/**
 * A list of inviteToJoinBody
 */
export const zInviteToJoinListBody = z.object({
    items: z.array(zInviteToJoinBody)
});

/**
 * InviteToJoin Properties
 */
export const zInviteToJoinPatchBody = z.object({
    profileIds: z.array(z.string()).max(5).optional()
});

/**
 * InviteToJoin Properties
 */
export const zInviteToJoinPostBody = z.object({
    email: zCharacterStringEmail,
    profileIds: z.array(z.string()).max(5)
});

/**
 * The virtual owner user of the business partner
 */
export const zOwnerBody = z.object({
    businessPartnerId: zCharacterStringUuid,
    identity: zIdentityBody,
    identityId: zCharacterStringUuid,
    profileIds: z.array(z.string())
});

/**
 * A paginated list of identityBody
 */
export const zPaginatedIdentityListBody = z.object({
    items: z.array(zIdentityBody),
    limit: z.number().int(),
    page: z.number().int(),
    total: z.number().int()
});

/**
 * Profile
 */
export const zProfileBody = z.object({
    description: z.string(),
    displayName: z.string(),
    focusIndustry: z.string(),
    name: z.string(),
    profileId: z.string()
});

/**
 * A list of profiles available for the current BusinessPartner
 */
export const zProfileListBody = z.object({
    items: z.array(zProfileBody)
});

/**
 * RequestToJoin Properties
 */
export const zRequestToJoinPostBody = z.object({
    businessPartnerId: zCharacterStringUuid
});

/**
 * A reviewer who can approve or reject a RequestToJoin
 */
export const zReviewerBody = z.object({
    email: z.string()
});

/**
 * RequestToJoin Properties
 */
export const zRequestToJoinBody = z.object({
    businessPartner: zBusinessPartnerBody.optional(),
    businessPartnerId: zCharacterStringUuid,
    createdAt: z.string().datetime(),
    id: zCharacterStringUuid,
    identity: zIdentityBody.optional(),
    identityId: zCharacterStringUuid,
    modifiedAt: z.string().datetime(),
    reviewers: z.array(zReviewerBody).optional()
});

/**
 * A list of requestToJoinBody
 */
export const zRequestToJoinListBody = z.object({
    items: z.array(zRequestToJoinBody)
});

/**
 * A list of role
 */
export const zRoleListBody = z.object({
    items: z.array(z.string())
});

/**
 * Support token response
 */
export const zSupportTokenBody = z.object({
    token: z.string().min(1)
});

/**
 * Request to create a support token for Topcon support
 */
export const zSupportTokenPostBody = z.object({
    identityId: zCharacterStringUuid,
    reason: z.string().min(1).max(500),
    ticket: z.string().min(1).max(100)
});

/**
 * target options for opening linked documents
 */
export const zTargetEnum = z.enum(['_blank']);

/**
 * OAuth Client App Properties
 */
export const zAppBody = z.object({
    category: zCharacterString150,
    description: zCharacterString255,
    glyphIcon: zCharacterString150.optional(),
    homepageURL: zCharacterStringHomepageUrl,
    iconURL: zCharacterStringSecureUrl.optional(),
    id: zCharacterStringUuid,
    name: zCharacterString255,
    target: zTargetEnum.optional()
});

/**
 * A list of appBody
 */
export const zAppListBody = z.object({
    items: z.array(zAppBody)
});

/**
 * User Properties
 */
export const zUserBody = z.object({
    businessPartner: zBusinessPartnerBody.optional(),
    businessPartnerId: zCharacterStringUuid,
    createdAt: z.string().datetime(),
    id: zCharacterStringUuid,
    identity: zIdentityBody.optional(),
    identityId: zCharacterStringUuid,
    modifiedAt: z.string().datetime(),
    profileIds: z.array(z.string()).max(5)
});

/**
 * BusinessPartner Properties
 */
export const zBusinessPartnerWithCurrentIdentityInfoBody = z.object({
    accessability: zBusinessPartnerAccessabilityEnum,
    archived: z.boolean(),
    createdAt: z.string().datetime(),
    extId: zCharacterStringUrn,
    iconURL: zCharacterStringSecureUrl.optional(),
    id: zCharacterStringUuid,
    isOwner: z.boolean().optional(),
    isSameDomain: z.boolean().optional(),
    modifiedAt: z.string().datetime(),
    name: zCharacterString255,
    ownerIdentityId: zCharacterStringUuid,
    parentBusinessPartnerId: zCharacterStringUuid.optional(),
    requestToJoin: zRequestToJoinBody.optional(),
    trn: zCharacterStringUrn,
    type: zCharacterStringType,
    user: zUserBody.optional()
});

/**
 * A list of businessPartnerWithCurrentIdentityInfoBody
 */
export const zBusinessPartnerWithCurrentIdentityInfoListBody = z.object({
    items: z.array(zBusinessPartnerWithCurrentIdentityInfoBody)
});

/**
 * A list of userBody
 */
export const zUserListBody = z.object({
    items: z.array(zUserBody)
});

/**
 * A list of userBody with an ownerBody
 */
export const zUserOwnerListBody = z.object({
    items: z.array(zUserBody),
    owner: zOwnerBody
});

/**
 * User Properties
 */
export const zUserPatchBody = z.object({
    profileIds: z.array(z.string()).max(5).optional()
});

/**
 * User Properties
 */
export const zUserPostBody = z.object({
    identityId: zCharacterStringUuid,
    profileIds: z.array(z.string()).max(5)
});

export const zGetV1BusinessPartnerCurrentQuery = z.object({
    icon: z.string().optional()
});

/**
 * Successful Response
 */
export const zGetV1BusinessPartnerCurrentResponse = zBusinessPartnerBody;

/**
 * TODO
 */
export const zPutV1BusinessPartnerCurrentBody = zBusinessPartnerPatchBody;

export const zPutV1BusinessPartnerCurrentHeaders = z.object({
    'If-Match': z.string().optional()
});

/**
 * Successful Response
 */
export const zPutV1BusinessPartnerCurrentResponse = zBusinessPartnerBody;

/**
 * Successful Response
 */
export const zGetV1BusinessPartnerCurrentDivisionsResponse = zBusinessPartnerWithCurrentIdentityInfoListBody;

/**
 * No Content
 */
export const zDeleteV1BusinessPartnerCurrentIconResponse = z.void();

/**
 * TODO
 */
export const zPostV1BusinessPartnerCurrentIconBody = z.object({
    thumbnail: z.string()
});

/**
 * Successful Response
 */
export const zGetV1BusinessPartnerCurrentProfilesResponse = zProfileListBody;

export const zGetV1BusinessPartnerCurrentSuggestIdentitiesQuery = z.object({
    suggest: z.string().optional()
});

/**
 * Successful Response
 */
export const zGetV1BusinessPartnerCurrentSuggestIdentitiesResponse = zIdentityListBody;

/**
 * Successful Response
 */
export const zGetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponse = zBusinessPartnerWithCurrentIdentityInfoBody;

/**
 * Successful Response
 */
export const zGetV1ContextResponse = zContextBody;

/**
 * TODO
 */
export const zPostV1DomainBody = zDomainPostBody;

/**
 * Created
 */
export const zPostV1DomainResponse = zDomainBody;

export const zDeleteV1DomainByIdPath = z.object({
    id: z.string()
});

export const zGetV1DomainByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1DomainByIdResponse = zDomainBody;

/**
 * TODO
 */
export const zPutV1DomainByIdBody = zDomainPatchBody;

export const zPutV1DomainByIdHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1DomainByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1DomainByIdResponse = zDomainBody;

export const zPutV1DomainByIdVerifyHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1DomainByIdVerifyPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1DomainByIdVerifyResponse = zDomainBody;

/**
 * Successful Response
 */
export const zGetV1DomainsResponse = zDomainListBody;

export const zGetV1IdentitiesQuery = z.object({
    page: z.number().int().optional(),
    limit: z.number().int().optional(),
    'filter[email]': z.record(z.unknown()).optional(),
    'filter[name]': z.record(z.unknown()).optional(),
    sort: z.record(z.unknown()).optional(),
    search: z.string().optional()
});

/**
 * Successful Response
 */
export const zGetV1IdentitiesResponse = zPaginatedIdentityListBody;

export const zGetV1IdentityCurrentQuery = z.object({
    external: z.string().optional()
});

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentResponse = zIdentityBody;

/**
 * TODO
 */
export const zPutV1IdentityCurrentBody = zIdentityPatchBody;

export const zPutV1IdentityCurrentHeaders = z.object({
    'If-Match': z.string().optional()
});

/**
 * Successful Response
 */
export const zPutV1IdentityCurrentResponse = zIdentityBody;

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentBusinessPartnersResponse = zBusinessPartnerWithCurrentIdentityInfoListBody;

export const zDeleteV1IdentityCurrentInviteToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * No Content
 */
export const zDeleteV1IdentityCurrentInviteToJoinByIdResponse = z.void();

export const zPostV1IdentityCurrentInviteToJoinByIdAcceptPath = z.object({
    id: z.string()
});

/**
 * Created
 */
export const zPostV1IdentityCurrentInviteToJoinByIdAcceptResponse = zUserBody;

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentInvitesToJoinResponse = zInviteToJoinListBody;

export const zDeleteV1IdentityCurrentRequestToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * No Content
 */
export const zDeleteV1IdentityCurrentRequestToJoinByIdResponse = z.void();

export const zGetV1IdentityCurrentRequestToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentRequestToJoinByIdResponse = zRequestToJoinBody;

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentRequestsToJoinResponse = zRequestToJoinListBody;

export const zDeleteV1IdentityCurrentUserByIdPath = z.object({
    id: z.string()
});

/**
 * No Content
 */
export const zDeleteV1IdentityCurrentUserByIdResponse = z.void();

/**
 * Successful Response
 */
export const zGetV1IdentityCurrentUsersResponse = zUserListBody;

/**
 * TODO
 */
export const zPostV1IdentityProviderBody = zIdentityProviderPostBody;

/**
 * Created
 */
export const zPostV1IdentityProviderResponse = zIdentityProviderBody;

export const zDeleteV1IdentityProviderByIdPath = z.object({
    id: z.string()
});

export const zGetV1IdentityProviderByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1IdentityProviderByIdResponse = zIdentityProviderBody;

/**
 * TODO
 */
export const zPutV1IdentityProviderByIdBody = zIdentityProviderPatchBody;

export const zPutV1IdentityProviderByIdHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1IdentityProviderByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1IdentityProviderByIdResponse = zIdentityProviderBody;

/**
 * Successful Response
 */
export const zGetV1IdentityProvidersResponse = zIdentityProviderListBody;

/**
 * TODO
 */
export const zPostV1InviteToJoinBody = zInviteToJoinPostBody;

/**
 * Created
 */
export const zPostV1InviteToJoinResponse = zInviteToJoinBody;

export const zDeleteV1InviteToJoinByIdPath = z.object({
    id: z.string()
});

export const zGetV1InviteToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1InviteToJoinByIdResponse = zInviteToJoinBody;

/**
 * TODO
 */
export const zPutV1InviteToJoinByIdBody = zInviteToJoinPatchBody;

export const zPutV1InviteToJoinByIdHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1InviteToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1InviteToJoinByIdResponse = zInviteToJoinBody;

/**
 * Successful Response
 */
export const zGetV1InvitesToJoinResponse = zInviteToJoinListBody;

/**
 * TODO
 */
export const zPostV1OauthClientBody = zClientPostBody;

/**
 * Created
 */
export const zPostV1OauthClientResponse = zClientBody;

export const zDeleteV1OauthClientByIdPath = z.object({
    id: z.string()
});

export const zGetV1OauthClientByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1OauthClientByIdResponse = zClientBody;

/**
 * TODO
 */
export const zPutV1OauthClientByIdBody = zClientPatchBody;

export const zPutV1OauthClientByIdHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1OauthClientByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1OauthClientByIdResponse = zClientBody;

/**
 * TODO
 */
export const zPostV1OauthClientByIdIconBody = z.object({
    thumbnail: z.string()
});

export const zPostV1OauthClientByIdIconPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1OauthClientsResponse = zClientListBody;

/**
 * Successful Response
 */
export const zGetV1OauthClientsCategoriesResponse = zAppCategoriesBody;

/**
 * TODO
 */
export const zPostV1RequestToJoinBody = zRequestToJoinPostBody;

/**
 * Created
 */
export const zPostV1RequestToJoinResponse = zRequestToJoinBody;

export const zDeleteV1RequestToJoinByIdPath = z.object({
    id: z.string()
});

export const zGetV1RequestToJoinByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1RequestToJoinByIdResponse = zRequestToJoinBody;

/**
 * Successful Response
 */
export const zGetV1RequestsToJoinResponse = zRequestToJoinListBody;

/**
 * Successful Response
 */
export const zGetV1RolesCurrentResponse = zRoleListBody;

/**
 * TODO
 */
export const zPostV1SupportTokenBody = zSupportTokenPostBody;

/**
 * Created
 */
export const zPostV1SupportTokenResponse = zSupportTokenBody;

/**
 * TODO
 */
export const zPostV1UserBody = zUserPostBody;

/**
 * Created
 */
export const zPostV1UserResponse = zUserBody;

/**
 * Successful Response
 */
export const zGetV1UserCurrentResponse = zUserBody;

/**
 * Successful Response
 */
export const zGetV1UserCurrentAppsResponse = zAppListBody;

/**
 * Successful Response
 */
export const zGetV1UserCurrentOauthClientsResponse = zAppListBody;

export const zDeleteV1UserByIdPath = z.object({
    id: z.string()
});

/**
 * No Content
 */
export const zDeleteV1UserByIdResponse = z.void();

export const zGetV1UserByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zGetV1UserByIdResponse = zUserBody;

/**
 * TODO
 */
export const zPutV1UserByIdBody = zUserPatchBody;

export const zPutV1UserByIdHeaders = z.object({
    'If-Match': z.string().optional()
});

export const zPutV1UserByIdPath = z.object({
    id: z.string()
});

/**
 * Successful Response
 */
export const zPutV1UserByIdResponse = zUserBody;

/**
 * Successful Response
 */
export const zGetV1UsersResponse = zUserOwnerListBody;
